import * as types from "./enderecoCobranca.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";

export default {
  setEnderecoCobranca: data => ({
    type: types.ENDERECOCOBRANCA_SET,
    payload: data
  }),
  resetForm: () => ({
    type: commonActionType.RESET
  }),
  getDadosEnderecoPrincipal: () => ({
    type: types.GET_DADOS_ENDERECO_PRINCIPAL
  })
}

